import { useTimer } from '@cloai/uikit';

export const useLimitedTimer = (endDate: Date | '') => {
  const time = useTimer(endDate);

  if (!time) {
    return null;
  }

  const days = time?.days ?? 0;
  const hours = time?.hours ?? 0;
  const minutes = time?.minutes ?? 0;
  const seconds = time?.seconds ?? 0;

  const isLeft30mins = days === 0 && hours === 0 && minutes < 30;

  return {
    days,
    hours,
    minutes,
    seconds,
    isLeft30mins,
  };
};
